/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Firstnamerequired2Inputs */

const en_firstnamerequired2 = /** @type {(inputs: Firstnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name is required`)
};

const de_firstnamerequired2 = /** @type {(inputs: Firstnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "First name is required" |
*
* @param {Firstnamerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const firstnamerequired2 = /** @type {((inputs?: Firstnamerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Firstnamerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_firstnamerequired2(inputs)
	return de_firstnamerequired2(inputs)
});
export { firstnamerequired2 as "firstNameRequired" }